import * as ActionTypes from 'src/constants/ActionTypes';
import { IAgentInfo, IAgentSetting } from 'src/entity/AgentEntity';
import { IStateUser } from 'src/entity/StateEntity';
import { IDrugStoreInfo, ISubDrugStore, IFreightTemplate, ProcessMethod } from 'src/entity/DrugStoreEntity';
import { Dispatch } from 'react';
import LoginService from 'src/services/LoginService';
import I18N from 'src/services/I18NService';
import { message } from 'antd';
import AgentService from 'src/services/AgentService';
import DrugStoreService from 'src/services/DrugStoreService';

function setAgentInfo(userInfo: IAgentInfo): IStateUser {
  return {
    isAgent: true,
    isDomestic: userInfo.is_domestic,
    type: ActionTypes.USER_TYPE_AGENT,
    userInfo,
  };
}

function setDrugStoreInfo(userInfo: IDrugStoreInfo): IStateUser {
  return {
    isAgent: false,
    isDomestic: userInfo.is_domestic,
    type: ActionTypes.USER_TYPE_DRUG_STORE,
    userInfo,
  };
}

export function clearUserInfo(): IStateUser {
  return {
    isAgent: true,
    isDomestic: true,
    type: ActionTypes.DATA_CLEAR,
    userInfo: undefined,
  };
}

export function getUserInfo(): (dispatch: Dispatch<IStateUser>) => Promise<void> {
  return async (dispatch: Dispatch<IStateUser>) => {
    try {
      const userInfo = await LoginService.getCurrentAgent();
      if (!!userInfo) {
        if (!userInfo.hasOwnProperty('agent_set')) {
          dispatch(setAgentInfo(userInfo as IAgentInfo));
        } else {
          dispatch(setDrugStoreInfo(userInfo as IDrugStoreInfo));
        }
        if (userInfo.is_domestic) {
          await I18N.forceDefault();
        }
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_login_failure'));
      }
    }
  };
}

export function getMethodDes(method: ProcessMethod): string {
  let name = '';
  switch (method) {
    case ProcessMethod.HerbalDecoction:
      name = I18N.get('order_decoction');
      break;
    case ProcessMethod.TinPowder:
      name = I18N.get('order_tiny_powder');
      break;
    case ProcessMethod.Powder:
      name = I18N.get('order_powder');
      break;
    case ProcessMethod.Paste:
      name = I18N.get('order_paste');
      break;
    case ProcessMethod.CondensePaste:
      name = I18N.get('order_condense_paste');
      break;
    case ProcessMethod.Pill:
      name = I18N.get('order_pill');
      break;
    case ProcessMethod.BigPill:
      name = '制大蜜丸';
      break;
    case ProcessMethod.SmallPill:
      name = '制小蜜丸';
      break;
    case ProcessMethod.WaterPill:
      name = I18N.get('order_water_pill');
      break;
    case ProcessMethod.CondensePill:
      name = I18N.get('order_condense_pill');
      break;
    case ProcessMethod.Capsule:
      name = I18N.get('order_capsule');
      break;
    case ProcessMethod.DecoctionAndGrain:
      name = '共煎制粒';
      break;
    case ProcessMethod.Alcohol:
      name = '制酒剂';
      break;
    case ProcessMethod.GrainAndPaste:
      name = '颗粒剂制膏';
      break;
    case ProcessMethod.CondenseDecoction:
      name = '浓煎剂';
      break;
    case ProcessMethod.SelfDecoction:
      name = '自煎';
      break;
  }
  return name;
}



export function updateAgentInfo(agentInfo: IAgentSetting) {
  return async (dispatch: Dispatch<IStateUser>) => {
    try {
      const res: IAgentInfo = await AgentService.updateAgentSetting(agentInfo);
      if (!!res) {
        dispatch(setAgentInfo(res));
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_save_failure'));
      }
    }
  };
}

export function updateDrugStoreInfo(drugStoreInfo: ISubDrugStore, drugStoreId: number) {
  return async (dispatch: Dispatch<IStateUser>) => {
    try {
      const res: IDrugStoreInfo = await DrugStoreService.updateDrugStore(drugStoreInfo, drugStoreId);
      if (!!res) {
        dispatch(setDrugStoreInfo(res));
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_save_failure'));
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/userCreator.ts